/**
 * Converts camelCase string to Title Case with spaces
 * Example: "participantEnrollmentForm" -> "Participant Enrollment Form"
 *
 * If the string doesn't appear to be camelCase (e.g., already has spaces or proper formatting),
 * it returns the string as-is to preserve the original formatting.
 */
export const camelCaseToTitleCase = (str: string): string => {
  if (!str) return str;

  // If the string already contains spaces, it's likely already formatted
  // Return as-is to preserve original formatting
  if (str.includes(" ")) {
    return str;
  }

  // Check if the string contains camelCase pattern (lowercase/digit followed by uppercase)
  // If not, it might be all lowercase, all uppercase, or already formatted
  if (!/[a-z0-9][A-Z]/.test(str)) {
    // If it's all lowercase and looks like it could be camelCase (has multiple words implied),
    // we'll still try to format it, but for single words, return as-is
    // For now, return as-is for non-camelCase strings
    return str;
  }

  // Insert a space before each uppercase letter that follows a lowercase letter or digit
  // eslint-disable-next-line prefer-string-replace-all
  const withSpaces = str.replace(/([a-z0-9])([A-Z])/g, "$1 $2");

  // Capitalize the first letter of each word
  return withSpaces
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
